// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import qs from 'qs';
import { postSSO } from '../../../modules/actions';
import { Preloader } from '../../../components';
import isAuthenticated from '../../../utils/auth/isAuthenticated';

const mapStateToProps = state => ({
	is_authenticated: isAuthenticated()
});

const mapDispatchToProps = ({
	postSSO,
});

type Props = {
	children: React.Node,
	is_authenticated: boolean,
	location: Object,
	postSSO: Function,
	history: Object
};

class SSOComponent extends React.Component<Props> {
	componentDidMount() {
		const {
			location: { search },
			postSSO: userLogin
		} = this.props;

		if (this.is_login_required) {
			const {
				code,
				state: redirect_url,
			} = qs.parse(search, { ignoreQueryPrefix: true });

			if (code) {
				userLogin({
					code,
					redirect_url
				});
			}
		}
	}

	get is_login_required() {
		const { location: { search } } = this.props;

		return search.includes('code');
	}

	render() {
		const {
			children,
			is_authenticated,
		} = this.props;

		return (this.is_login_required && !is_authenticated) ? <Preloader /> : children;
	}
}

export const SSO = connect(
	mapStateToProps,
	mapDispatchToProps,
)(withRouter(SSOComponent));

export default SSO;


// WEBPACK FOOTER //
// ./src/components/utils/SSO/index.js